import { Routes } from '@angular/router';
import { AuthGuard } from './core/security/guard/auth.guard';
import { HomeComponent } from './feature/general/home/home.component';

export const routes: Routes = [
  {
    path: 'public',
    loadChildren: () => import('./feature/public-device/public-device.module').then((m) => m.PublicDeviceModule),
  },
  {
    path: 'login',
    loadChildren: () => import('./feature/authentication/authentication.module').then((m) => m.AuthenticationModule),
  },
  {
    path: 'access',
    loadChildren: () => import('./feature/authentication/authentication.module').then((m) => m.AuthenticationModule),
  },
  {
    path: 'not-authorized',
    loadChildren: () => import('./feature/authentication/authentication.module').then((m) => m.AuthenticationModule),
  },
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'locations/:locationId/devices',
    canActivate: [AuthGuard],
    loadChildren: () => import('./feature/devices/devices.module').then((module) => module.DevicesModule),
  },
  {
    path: 'locations/:locationId/events',
    canActivate: [AuthGuard],
    loadChildren: () => import('./feature/events/events.module').then((module) => module.EventsModule),
  },
  {
    path: 'locations/:locationId/notifications',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./feature/notifications/notifications.module').then((module) => module.NotificationsModule),
  },
  {
    path: 'locations/:locationId',
    pathMatch: 'full',
    canActivate: [AuthGuard],
    loadChildren: () => import('./feature/dashboard/dashboard.module').then((module) => module.DashboardModule),
  },
  {
    path: 'locations/:locationId',
    canActivate: [AuthGuard],
    loadChildren: () => import('./feature/setup-check/setup-check.module').then((module) => module.SetupCheckModule),
  },
  {
    path: 'sites',
    canActivate: [AuthGuard],
    loadChildren: () => import('./feature/multisites/multisites.module').then((module) => module.MultisitesModule),
  },
  {
    path: 'locations/:locationId/device-groups',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./feature/device-groups/device-groups.module').then((module) => module.DeviceGroupsModule),
  },
  {
    path: 'locations/:locationId/gateways',
    canActivate: [AuthGuard],
    loadChildren: () => import('./feature/gateways/gateways.module').then((module) => module.GatewaysModule),
  },
  {
    path: 'locations/:locationId/settings',
    canActivate: [AuthGuard],
    loadChildren: () => import('./feature/settings/settings.module').then((module) => module.SettingsModule),
  },
  {
    path: 'locations/:locationId/admin',
    canActivate: [AuthGuard],
    loadChildren: () => import('./feature/admin/admin.module').then((module) => module.AdminModule),
  },
  {
    path: 'help',
    canActivate: [AuthGuard],
    loadChildren: () => import('./feature/help/help.module').then((module) => module.HelpModule),
  },
  {
    path: 'user-preferences',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./feature/user-preferences/user-preferences.module').then((module) => module.UserPreferencesModule),
  },
  {
    path: 'admin',
    canActivate: [AuthGuard],
    loadChildren: () => import('./feature/admin/admin.module').then((module) => module.AdminModule),
  },
  {
    path: 'install',
    canActivate: [AuthGuard],
    loadChildren: () => import('./feature/install/install.module').then((module) => module.InstallModule),
  },

  //Wild Card Route for 404 request
  {
    path: '**',
    redirectTo: '/',
  },
];
